export const Offers = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Tag body - outline only (matches the stroke-based icons like Bills) */}
      <path
        d="M12.5 3H5C3.89543 3 3 3.89543 3 5V12.5C3 13.0304 3.21071 13.5391 3.58579 13.9142L11.0858 21.4142C11.8668 22.1953 13.1332 22.1953 13.9142 21.4142L21.4142 13.9142C22.1953 13.1332 22.1953 11.8668 21.4142 11.0858L13.9142 3.58579C13.5391 3.21071 13.0304 3 12.5 3Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      {/* Tag hole */}
      <circle
        cx="7.25"
        cy="7.25"
        r="1.4"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.4"
      />
      {/* Percent slash */}
      <path
        d="M14.75 9.25L9.25 14.75"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      {/* Percent circles */}
      <circle cx="10.15" cy="10.15" r="0.95" fill="currentColor" />
      <circle cx="13.85" cy="13.85" r="0.95" fill="currentColor" />
    </svg>
  );
};
